import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";
const PurchaseReturnComponent = loadable(
  () => import("../../components/PurchaseReturn/index")
);
const PurchaseReturnList = () => {
  return (
    <>
      <div className={tw`flex items-center justify-between`}>
        <h1 className={tw`font-semibold text-2xl leading-8`}>
          Purchase Return
        </h1>
      </div>
      <PurchaseReturnComponent />
    </>
  );
};

export default PurchaseReturnList;
